export default __webpack_public_path__ + "static/media/ProductsList_img2_Hk.3b3f16b3.webp";